function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { isBoolean, isFunction, isObject, isUndefined } from '@okee-uikit/react-utils';
import { useRef } from 'react';
import { useConstCallback, useRefCallback } from '../callback';
import { useForceUpdate } from '../misc';
import { useConst } from '../state';
export function usePartial() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var value = options.value,
      onChange = options.onChange,
      _options$defaultValue = options.defaultValue,
      defaultValue = _options$defaultValue === void 0 ? value : _options$defaultValue,
      _options$controlled = options.controlled,
      controlled = _options$controlled === void 0 ? !isUndefined(value) : _options$controlled,
      onPartChange = options.onPartChange,
      partControlled = options.partControlled;
  var fallbackValue = useConst({});
  var forceUpdate = useForceUpdate();
  var valueRef = useRef(undefined);

  if (!valueRef.current) {
    var initialValue = isFunction(defaultValue) ? defaultValue() : defaultValue;
    valueRef.current = {
      value: isObject(initialValue) && initialValue || fallbackValue
    };
  }

  var getFinalValue = useRefCallback(function () {
    if (isObject(value)) {
      if (controlled) {
        if (!isObject(partControlled)) {
          return value;
        }

        var entris = Object.entries(partControlled).filter(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              v = _ref2[1];

          return isBoolean(v) && !v;
        });

        if (entris.length === 0) {
          return value;
        }

        var unControlledPart = {};
        entris.map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 1),
              k = _ref4[0];

          unControlledPart[k] = valueRef.current.value[k];
        });
        return _objectSpread(_objectSpread({}, value), unControlledPart);
      }

      if (isObject(partControlled)) {
        var entries = Object.entries(partControlled).filter(function (_ref5) {
          var _ref6 = _slicedToArray(_ref5, 2),
              v = _ref6[1];

          return isBoolean(v) && v;
        });

        if (entries.length === 0) {
          return valueRef.current.value;
        }

        var controlledPart = {};
        entries.map(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 1),
              k = _ref8[0];

          controlledPart[k] = value[k];
        });
        return _objectSpread(_objectSpread({}, valueRef.current.value), controlledPart);
      }
    }

    return valueRef.current.value;
  });
  valueRef.current.value = getFinalValue();
  var setValueOrCallOnChange = useRefCallback(function (updater, event) {
    var oldValue = valueRef.current.value;
    var newValue = isFunction(updater) ? updater(valueRef.current.value) : updater;
    valueRef.current.value = isObject(newValue) && newValue || fallbackValue;

    if (!controlled) {
      forceUpdate();
    }

    onChange === null || onChange === void 0 ? void 0 : onChange(valueRef.current.value, event);

    if (isObject(onPartChange)) {
      Object.entries(onPartChange).forEach(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            key = _ref10[0],
            callback = _ref10[1];

        var oldPart = oldValue[key];
        var newPart = valueRef.current.value[key];

        if (isFunction(callback) && oldPart !== newPart) {
          callback(newPart, event);
        }
      });
    }
  });
  var setPartial = useConstCallback(function (updater, event) {
    setValueOrCallOnChange(function (pre) {
      var newPartial = isFunction(updater) ? updater(pre) : updater;

      if (!isObject(newPartial)) {
        return pre;
      }

      return _objectSpread(_objectSpread({}, pre), newPartial);
    }, event);
  });
  var clear = useConstCallback(function (event) {
    return setValueOrCallOnChange({}, event);
  });
  var actions = useConst({
    setValue: setValueOrCallOnChange,
    setPartial: setPartial,
    clear: clear
  });
  return [valueRef.current.value, actions];
}